import React from 'react';
import { ts } from 'src/utils/translate';

export const PlannerSvg = (props: { floorWifiSvgObject: any }) => {
  const { floorWifiSvgObject } = props;

  return (
    <React.Fragment>
      <div
        dangerouslySetInnerHTML={{
          __html: floorWifiSvgObject.plannerSVG[0].outerHTML,
        }}
      ></div>
      <span style={{ fontSize: 10, color: "#c0c0c0" }}>
        *{ts("q_approx_vals", "Approximate values")}
      </span>
    </React.Fragment>
  );
};
